import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import TileSelection from '../../../../../common/Tile/TileSelection';
import type { TileConfig } from '../../../../../common/Tile/TileSelection';
import Heading from '../../../../../common/Heading';
import type { WizardTileConfig } from '../../types/tileConfig';
import s from './StepGenericTile.module.scss';

interface StepGenericTileProps {
  /** The name of the tile selection (is also the name of the formik field) */
  name: string;
  /** Message id for the heading */
  msgId: string;
  /** Some pages have a different heading for the mobile view */
  mobileHeaderMsgId?: string;
  /** Optional intro message before the heading */
  introMsgId?: string;
  /** Tile configs (urlValue entries are used by the wizard router) */
  tileConfigs: WizardTileConfig[];
  onNext?: (selectedValue?: string) => void | Promise<void>;
}

function StepGenericTile({
  name,
  msgId,
  mobileHeaderMsgId = '',
  tileConfigs,
  introMsgId,
  onNext,
}: StepGenericTileProps) {
  const tileConfigsForSelection: TileConfig[] = tileConfigs;

  return (
    <>
      {introMsgId && (
        <p className={s.intro}>
          <FormattedMessage id={introMsgId} />
        </p>
      )}
      <Heading level={2} className={`${s.heading} ${s.desktopHeading}`}>
        <FormattedMessage id={msgId} />
      </Heading>
      <Heading level={2} className={`${s.heading} ${s.mobileHeading}`}>
        <FormattedMessage id={mobileHeaderMsgId || msgId} />
      </Heading>
      <Field
        id={name}
        name={name}
        component={TileSelection}
        tileConfigs={tileConfigsForSelection}
        onNext={onNext}
      />
    </>
  );
}

export default StepGenericTile;
